import { themes } from '@lokalise/louis';

import generateThemeColors from '../customColor';
import { palette } from '../customPalette';
import customTypography from '../customTypography';
import zIndices from '../zIndices/zIndices.json'; // eslint-disable-line import/extensions
import { boxShadow, breakpoints, typographyExtends } from './base';

const customColor = generateThemeColors(palette, 'dark');

export default {
    ...themes.dark,
    typography: {
        ...themes.dark.typography,
        custom: {
            ...customTypography,
            ...typographyExtends,
        },
    },
    color: {
        ...themes.dark.color,
        custom: customColor,
    },
    zIndex: zIndices,
    breakpoints,
    boxShadow,
};
